import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class ListTask extends AbstractRequestTask {
    constructor(url, params = {}) {
        super();

        this.url = url;
        this.params = params;
    }

    getHeaders() {
        return {};
    }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");

      return `${http}${url}${this.url}`;
    }

    getParams() {
        const params = super.getParams();
        if (this.url.includes('/v1/')) {
            delete params.api_version;
        }
        return Object.assign({}, params, this.params);
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }
}

export default ListTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/content/ListTask.js